import * as a0 from "@grins/assets/versions" with { type: "json" }
let a0_ = "" + void a0;